import { Box } from '@mui/material';
import { DrawerId, SideDrawer } from 'src/components/containers/SideDrawer';
import AiChatDragAndDrop from './AiChatDragAndDrop';
import AiChatDrawerContent from './AiChatDrawerContent';
import AiChatDrawerHeader from './AiChatDrawerHeader';
import AiChatHistory from './AiChatHistory';

export default function AiChatDrawer() {
  return (
    <AiChatDragAndDrop>
      <SideDrawer
        drawerId={DrawerId.AI_CHAT}
        paperSx={{
          width: '66%',
          maxWidth: '900px',
          overflow: 'hidden',
          p: 0,
          borderTopLeftRadius: '8px',
          borderBottomLeftRadius: '8px',
        }}
      >
        <Box sx={{ display: 'flex', height: '100%', overflow: 'hidden' }}>
          <AiChatHistory />
          <Box
            sx={{
              display: 'flex',
              flexDirection: 'column',
              height: '100%',
              flexGrow: 1,
              minWidth: 0,
              overflow: 'hidden',
              pt: '12px',
              pb: '36px',
            }}
          >
            <AiChatDrawerHeader />
            <Box
              sx={{
                display: 'flex',
                flexDirection: 'column',
                height: '100%',
                width: '100%',
                overflow: 'hidden',
                flexGrow: 1,
                minHeight: 0,
              }}
            >
              <AiChatDrawerContent />
            </Box>
          </Box>
        </Box>
      </SideDrawer>
    </AiChatDragAndDrop>
  );
}
